import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { useLabels } from 'wsm-common-data';
import { getSlug } from '../utils/helperFunctions';

const DeptHeading = ({ labelAlias }) => {
	const labels = useLabels();
	const labelValue = labels.get(labelAlias);

	return (
		<Row>
			<Col xs={12} sm={6}>
				<h2 className="mt-6 mb-5" id={getSlug(labelValue)}>
					{labelValue}
				</h2>
			</Col>
		</Row>
	);
};

DeptHeading.propTypes = {
	labelAlias: PropTypes.string.isRequired
};

export default DeptHeading;
